module.exports = __webpack_public_path__ + "img/group_add_opsz20.94169997.svg";